<script setup lang="ts">

</script>

<template>
    <div class="container mx-auto flex flex-col items-center gap-10 px-4 py-8 text-center footer-items text-[#f1ece5]">
        <div class="lg:text-lg">
            Wszystkie materiały są przeznaczone
            dla osób dorosłych powyżej 18 roku życia,
            nie należy ich przekazywać
            ani udostępniać osobom poniżej 18 lat.
            Pij odpowiedzialnie.
        </div>
        <a href="https://abcalkoholu.pl" target="_blank">
            <img src="@/assets/images/contact/abcalkoholu.webp" width="60%" alt="Logo abcalkoholu" class="mx-auto max-w-[400px]">
        </a>
        <div class="lg:text-lg2xl">
            Jeśli uważasz, że treść naszego serwisu
            narusza zasady Kodeksu
            Etyki Reklamy, <a href="https://radareklamy.pl/" target="_blank" class="text-kozel-brown item-bold"><span class="item-bold">zgłoś&nbsp;to!</span></a>
            Dowiedz się więcej o alkoholu
            na <a href="https://abcalkoholu.pl" target="_blank" class="text-kozel-brown font-bold"><span class="item-bold">abcalkoholu.pl.</span></a>
        </div>
        <div class="lg:text-lg">
            <div>2025 Wszelkie prawa zastrzeżone.</div>
            <a href="/polityka-prywatnosci">Polityka prywatności.</a>
        </div>
    </div>
</template>

<style scoped>
.footer-items div {
    font-family: 'ApexSerif', 'serif';
    font-weight: 400;
}

.item-bold {
    font-weight: 700;
}
</style>